import script from "./ApiLocalStorage.vue?vue&type=script&lang=js"
export * from "./ApiLocalStorage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__